import { headerConnect as connect } from 'components/Shared/connect';
import { useState, useEffect } from 'react';
import Modal from 'components/Shared/Modal';
import { SiteMode } from 'models/SiteMode';
import { Button } from 'components/Button';
import styles from './styles.scss';
import { rm } from 'utils';
import { getQaDataAttr } from '@bygghemmait/utilities';
import { clearModeInQueryString } from './actions';

interface MergedProps {
  hasChanged: boolean;
  isCompany: boolean;
  clearQueryString: () => void;
}

const _SiteModeChangedModal = ({ hasChanged, clearQueryString, isCompany }: MergedProps) => {
  const [show, setShow] = useState(false);
  const close = () => setShow(false);
  const [hasChangedLegacy] = useState(() => hasChanged);

  useEffect(() => {
    // Used for legacy pages, where we don't want to react to
    // hasChanged from props directly, otherwise the modal pops up
    // before we have reloaded the page. Show it on mount instead
    // the useState(() => props.hasChanged) ensures the value
    // will always be the same.
    if (hasChangedLegacy && !window.isReact) {
      setShow(true);
      clearQueryString();
    }
  }, [hasChangedLegacy, clearQueryString]);

  useEffect(() => {
    if (hasChanged && window.isReact) {
      setShow(true);
      clearQueryString();
    }
  }, [hasChanged, clearQueryString]);

  return (
    <Modal contentClassName={styles.siteModeChangedModal} onClose={close} show={show}>
      <h3 className={styles.welcome}>
        {isCompany ? rm('b2b_welcome_company') : rm('b2b_welcome_private')}
      </h3>
      <p>{isCompany ? rm('b2b_price_vat_excluded') : rm('b2b_price_vat_included')}</p>
      <Button onClick={close} {...getQaDataAttr('siteModeClose')} appearance="whitePill">
        {rm('shared_button_close')}
      </Button>
    </Modal>
  );
};

export const SiteModeChangedModal = connect<MergedProps>(
  state => ({
    hasChanged: state.location.search && state.location.search.mode !== undefined,
    isCompany: state.appShell.siteMode === SiteMode.Company
  }),
  dispatch => ({
    clearQueryString: () => dispatch(clearModeInQueryString())
  })
)(_SiteModeChangedModal);
